<template>
  <div v-auto-animate>
    <slot />
    <FormCaption
      v-if="hasErrors && !value"
      type="invalid"
      class="mt-3"
    >
      {{ firstError }}
    </FormCaption>
  </div>
</template>

<script>
import FormCaption from './FormCaption.vue';
import validation from './validation-mixin';

export default {
  name: 'RadioGroup',
  mixins: [validation],
  components: { FormCaption },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: {
      type: [String, Number],
    },
  },
};
</script>
